export class PaymentsTrackingServiceMock {
  pushTrackingData(data: unknown) {
    // Empty
  }
}
